import gsap from 'gsap';
import { eventBus } from './event-bus';

export const triggerLottie = ( setting, timers, index ) => {
	let targets = [],
		actions = [];

	setting?.settings?.forEach( ( ele, i ) => {
		const container = document.querySelector( ele.target );
		if ( container ) targets[ i ] = container.dataset.mookwaiid;
		actions[ i ] = ele.action || 'play';
	} );

	const execute = () => {
		targets.forEach( ( ele, i ) => {
			if ( ele ) {
				const event = `lottie-${ ele }-${ actions[ i ] }`;
				eventBus.emit( event );
			}
		} );
	};

	const run = () => {
		timers[ index ]?.kill();
		timers[ index ] = null;
		if ( setting.delay ) {
			timers[ index ] = gsap.delayedCall( setting.delay, execute );
		} else {
			execute();
		}
	};

	const kill = () => {
		targets = [];
		actions = [];
	};

	return { run, kill };
};
